import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "qin-footer" }
const _hoisted_2 = { class: "g-row g-row--space_xl g-row--justify_between g-row--align_center g-row--full-height" }
const _hoisted_3 = { class: "g-cell g-cols g-cols--auto" }
const _hoisted_4 = { class: "footer-element" }
const _hoisted_5 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "g-cell g-cols g-cols--narrow" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "footer-element" }, /*#__PURE__*/_toDisplayString('Website developed by WEBCASE'))
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString($setup.copyrihgth), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.textPages, (link, index) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["footer-element", {'last' : index ==  $setup.props.textPages.length - 1}])
          }, [
            _createVNode(_component_router_link, {
              class: "ds-link ds-link--userbar",
              to: { name: 'text-page', params: { slug: link.slug } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(link.title), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ], 2)
        ]))
      }), 256)),
      _hoisted_6
    ])
  ]))
}